module.exports = __webpack_public_path__ + "img/img2.1b2af297.png";